import { useMutation, useQueryClient } from "@tanstack/react-query";

import { inviteUsers, InviteUsersRequest } from "@/api";
import { useUIStore } from "@/stores";

const useInviteUsers = () => {
  const queryClient = useQueryClient();
  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: InviteUsersRequest) => inviteUsers(body),
    meta: {
      error: "Something went wrong... Try again",
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["my-user"] });
      openToast({ message: "User is invited!", variant: "success" });
    },
  });
};

export { useInviteUsers };
